module.exports = __webpack_public_path__ + "static/plan-update-category_1-d49bb1fa1a6a6443993a4b3aa9ef8cd1.png";